import * as React from 'react';
import {observer} from "mobx-react";
import {HRAlert} from "components/hr/HRAlert";
import {HRTitleBar} from "components/hr/HRTitleBar";
import {HRFooter} from "components/hr/HRFooter";
import {HRMain} from "components/hr/HRMain";
import './HRApp.pcss';

export const HRApp = observer(() =>
  <section>
      <div className={"hr-app"}>
        <HRTitleBar />
        <HRMain/>
        <HRFooter />
        <HRAlert />
      </div>
  </section>
);
